import React, { useState, useEffect, useRef } from "react";
import { updateProduct } from "../api/newprod";
import { getBids } from '../api/commerce';
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import DateObject from "react-date-object";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import "../css/CreateForm.css";


const MAX_IMAGE_SIZE = 25 * 1024 * 1024;   // 25 MB
const MAX_VIDEO_SIZE = 250 * 1024 * 1024;  // 250 MB
dayjs.extend(utc);
dayjs.extend(jalaliday);

const ProductForm = ({ product, onSave, onCancel }) => {
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    artist: "",
    material: "",
    style:"",
    feature_one: "",
    feature_two: "",
    length:"",
    width:"",
    height:"",
    weight:"",
    is_biddable: false,
    bidding_deadline: "",
    timezone: userTimezone,
    images: [],   
    videos: [],   
  });

  const [images, setImages] = useState([]); 
  const [videos, setVideos] = useState([]); 
  const [bids, setbids] = useState([])
  const [error, setError] = useState("");
  const [consoleError, setConsoleError] = useState("");
  const mediaInputRef = useRef(null);
  const [deliveryModesEn, setDeliveryModesEn] = useState({});
  const [deliveryModesFa, setDeliveryModesFa] = useState({});
  const [selectDeliveryMode, setDeliveryMode] = useState({});
  const [selectedSub, setSelectedSub] = useState("");

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  useEffect(() => {
    fetch("/data/DeliveryInfo.json")
      .then((res) => res.json())
      .then((data) => setDeliveryModesEn(data.DeliveryInformationEn))
      .catch((err) => setConsoleError("Error loading content:", err));
  },[]);

  useEffect(() => {
    fetch("/data/DeliveryInfo.json")
      .then((res) => res.json())
      .then((data) => setDeliveryModesFa(data.DeliveryInformationFa))
      .catch((err) => setConsoleError("Error loading content:", err));
  },[]);

  useEffect (() => {
    if (product.is_biddable) {
      getBids(product.id)
      .then (setbids)
      .catch(err => setConsoleError(err));
    }
  }, [product, product.is_biddable]);

  useEffect(() => {
    if (product) {
      setFormValues({
        name: product.name || "",
        description: product.description || "",
        price: product.price || "",
        category: product.category || "",
        artist: product.artist || "",
        material: product.material || "",
        feature_one: product.feature_one || "",
        feature_two: product.feature_two || "",
        length: product.length || "",
        width: product.width || "",
        height: product.height || "",
        weight: product.weight || "",
        style: product.style || "",
        delivered_by: product.delivered_by || "",
        pickup_address: product.pickup_address || "",
        is_biddable: product.is_biddable || false,
        bidding_deadline: product.bidding_deadline
          ? product.bidding_deadline.split("T")[0] // yyyy-MM-dd only
          : "",
        images: [],   
        videos: [],  
        timezone: userTimezone, 
      });
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "checkbox") {
      setFormValues((prev) => ({ ...prev, [name]: checked }));
    } else if (type === "file") {
      setFormValues((prev) => ({
        ...prev,
        [name]: Array.from(files),
      }));
    } else {
      setFormValues((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDeliveryMode = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
    setDeliveryMode(e.target.value);
  };
  
  const handleMediaChange = (e) => {
    setError("");
    const files = Array.from(e.target.files || []);
    const newImages = [];
    const newVideos = [];

    for (const file of files) {
      if (!file.type) {
        newVideos.push(file);
        continue;
      }

      if (file.type.startsWith("image/")) {
        if (file.size > MAX_IMAGE_SIZE) {
          if (setlang === "en") {
          setError(`Image "${file.name}" exceeds max size (${MAX_IMAGE_SIZE / (1024 * 1024)}MB).`);
          alert(`Image "${file.name}" exceeds max size (${MAX_IMAGE_SIZE / (1024 * 1024)}MB).`);
          } else {
          setError(`حجم عکس "${file.name}" بیشتر از حد مجاز (${MAX_IMAGE_SIZE / (1024 * 1024)}MB) است.`);
          alert(`حجم عکس "${file.name}" بیشتر از حد مجاز (${MAX_IMAGE_SIZE / (1024 * 1024)}MB) است.`);
          }          
          continue;
        }
        newImages.push(file);
      } else if (file.type.startsWith("video/")) {
        if (file.size > MAX_VIDEO_SIZE) {
          if (setlang === "en") { 
          setError(`Video "${file.name}" exceeds max size (${MAX_VIDEO_SIZE / (1024 * 1024)}MB).`);
          alert(`Video "${file.name}" exceeds max size (${MAX_VIDEO_SIZE / (1024 * 1024)}MB).`);
          } else {
          setError(`حجم ویدیو "${file.name}" بیشتر از حد مجاز (${MAX_VIDEO_SIZE / (1024 * 1024)}MB) است.`);
          alert(`حجم ویدیو "${file.name}" بیشتر از حد مجاز (${MAX_VIDEO_SIZE / (1024 * 1024)}MB) است.`);
          }
          continue;
        }
        newVideos.push(file);
      } else {
        setError((prev) => prev + ` Unsupported file type: ${file.name}.`);
      }
    }

    if (files.length > 5) {
      if (setlang === "en") {
        setError("You have exceeded maximum number of 5 files");
        alert("You have exceeded maximum number of 5 files");
      } else {
        setError("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نمی‌باشد");
        alert("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نمی‌باشد");
      }
    } else {
      setImages(newImages);
      setVideos(newVideos);
    }
  };

  const [existingImages, setExistingImages] = useState([]);
  const [existingVideos, setExistingVideos] = useState([]);
  const [deleteImages, setDeleteImages] = useState([]);
  const [deleteVideos, setDeleteVideos] = useState([]);

  useEffect(() => {
    if (product) {
      setExistingImages(product.images || []);
      setExistingVideos(product.videos || []);
    }
  }, [product]);

  const markForDeletion = (type, id) => {
    if (type === "images") {
      setDeleteImages((prev) => [...prev, id]);
      setExistingImages((prev) => prev.filter((img) => String(img.id) !== String(id)));
    } else if (type === "videos") {
      setDeleteVideos((prev) => [...prev, id]);
      setExistingVideos((prev) => prev.filter((vid) => String(vid.id) !== String(id)));
    }
  };

  const normalizeNumber = (input) => {
    if (input == null || input === "") return "";

    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
    let str = String(input).trim();
    // Convert Persian/Arabic digits to English
    str = str.replace(/[۰-۹]/g, (d) => persianDigits.indexOf(d));
    str = str.replace(/[٠-٩]/g, (d) => arabicDigits.indexOf(d));
    // Remove spaces and Persian thousands separator
    str = str.replace(/[\s٬]/g, "");
    // Convert Arabic decimal separator to dot
    str = str.replace(/٫/g, ".");
    const lastComma = str.lastIndexOf(",");
    const lastDot = str.lastIndexOf(".");
    if (lastComma > lastDot) {
      // European format: 1.234,56
      str = str.replace(/\./g, "");
      str = str.replace(",", ".");
    } else {
      // US format: 1,234.56
      str = str.replace(/,/g, "");
    }
    
    const num = Number(str);
    return Number.isNaN(num) ? null : num.toString();
  };

  const NUMERIC_FIELDS = ["length", "width", "price", "height", "weight" ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if ((existingImages.length + existingVideos.length + images.length + videos.length) > 5) {
      if (setlang === "en") {
        setError("You have exceeded maximum number of 5 files");
        alert("You have exceeded maximum number of 5 files");
      } else {
        setError("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نمی‌باشد");
        alert("آگهی با بیش از ۵ عکس و یا ویدیو مجاز نمی‌باشد");
      }
    } else {

      try {
        const scalarChanges = {};
        Object.entries(formValues).forEach(([key, value]) => {

          if (["images", "videos"].includes(key)) return; 
    
          let original = product ? product[key] : "";
          let current = value;
    
          if (NUMERIC_FIELDS.includes(key)) {
            original = normalizeNumber(original);
            current = normalizeNumber(current);
          }
          if (key === "is_biddable") {
            original = Boolean(original);
            current = Boolean(current);
          }
          if (key === "bidding_deadline") {
            original = product?.bidding_deadline
              ? product.bidding_deadline.split("T")[0]
              : "";
          }
    
          if (original !== current) {
            scalarChanges[key] = value;
          }


        });
    
        // 2. Check if media changes exist
        const hasMediaChanges =
          images.length > 0 || videos.length > 0 || deleteImages.length > 0 || deleteVideos.length > 0;
    
        // 3. If nothing changed, skip update
        if (Object.keys(scalarChanges).length === 0 && !hasMediaChanges) {
          alert(setlang==="en"?"No changes detected.":"تغییری در شناسه شما پیدا نشد");
          return;
        }
    
        // 4. If media changes → use FormData
        if (hasMediaChanges) {
          const data = new FormData();
    
          // Scalars
          Object.entries(scalarChanges).forEach(([key, value]) => {
            if (key === "price") {
              data.set(key, normalizeNumber(value));
            } else if (key === "is_biddable") {
              data.set(key, value ? "true" : "false");
            } else if (key === "bidding_deadline" && value) {
              data.set(key, value + "T00:00:00Z");
            } else {
              data.set(key, value);
            }
          });
    
          // New uploads
          images.forEach((file) => data.append("images", file));
          videos.forEach((file) => data.append("videos", file));
    
          // Deletions
          deleteImages.forEach((id) => data.append("delete_images", id));
          deleteVideos.forEach((id) => data.append("delete_videos", id));
    
          await updateProduct(product.id, data, true);
        } else {
          // JSON-only update
          const payload = {
            ...scalarChanges,
            price: scalarChanges.price ? normalizeNumber(scalarChanges.price) : undefined,
            bidding_deadline: scalarChanges.bidding_deadline
              ? scalarChanges.bidding_deadline 
              : undefined,
          };
          
          await updateProduct(product.id, payload, false);
        }
        onSave();
      } catch (error) {
        alert(error.response?.data ? JSON.stringify(error.response.data, null, 2) : error.message);
      }
    }
  };
  

  return (
    <div className="product-UpdateForm-container">
      <button onClick={onCancel} className="modal-close">
        &#10005;
      </button>
      {setlang === "en" ?
      <h3 className="product-form-title">Edit Article</h3>:
      <h3 className="product-form-title">ویرایش آگهی</h3>
      }

      <form className={setlang === "en" ? "Product-UpdateForm" : "Product-UpdateForm-fa" } onSubmit={handleSubmit}>
        <label>
          {setlang === "en" ? "Name" : "نام محصول" }
          <input
            type="text"
            name="name"
            value={formValues.name}
            onChange={handleChange}
            required
            className="product-form-input"
          />
        </label>

        <label>
          {setlang === "en" ? "Description" : "توضیحات" }
          <textarea
            name="description"
            value={formValues.description}
            onChange={handleChange}
            className={setlang === "en" ? "product-form-textarea" : "product-form-textarea-fa" }
          />
        </label>

        <label >
          {setlang === "en" ? "Price" : "قیمت درخواستی" }
          <input
            type="decimal"
            name="price"
            value={formValues.price}
            onChange={handleChange}
            required
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Artist" : "اثر هنرمند" }
          <input
            type="text"
            name="artist"
            value={formValues.artist}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Category" : "دسته بندی" }
          <input
            type="text"
            name="category"
            value={formValues.category}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Style" : "استایل" }
          <input
            type="text"
            name="style"
            value={formValues.style}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Material" : "جنس ساخت" }
          <input
            type="text"
            name="material"
            value={formValues.material}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Special Features" : "ویژگی‌های خاص" }
          <input
            type="text"
            name="feature_one"
            value={formValues.feature_one}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Basic Features" : "ویژگی‌های دیگر" } 
          <input
            type="text"
            name="feature_two"
            value={formValues.feature_two}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>
        
        <label >
          {setlang === "en" ? "Length in cm" : "(cm) طول" }
          <input
            type="text"
            name="length"
            value={formValues.length}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Width in cm": "(cm) عرض" }
          <input
            type="text"
            name="width"
            value={formValues.width}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Heigth in cm" : "(cm) ارتفاع" }
          <input
            type="text"
            name="height"
            value={formValues.height}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <label >
          {setlang === "en" ? "Weigth in Kg": "(kg) وزن" } 
          <input
            type="text"
            name="weight"
            value={formValues.weight}
            onChange={handleChange}
            className="product-form-input"
          />
        </label>

        <div className="delivered_by">
          <label >
            {setlang === "en" ?
              <select type="text" name="delivered_by" value={formValues.delivered_by} onChange={handleDeliveryMode} className="narrow_select" placeholder="Delivered by:" >
                <option value=""> "-- Select Delivery Mode --"</option>
                {Object.keys(deliveryModesEn).map((cat, idx) => (
                <option key={idx} value={cat}> {cat} </option> ))}
              </select>
              :
              <select type="text" name="delivered_by" value={formValues.delivered_by} onChange={handleDeliveryMode} className="narrow_select" placeholder="Delivered by:" >
                <option value="">"-- شیوه ارسال  --"</option>
                {Object.keys(deliveryModesFa).map((cat, idx) => (
                <option key={idx} value={cat}> {cat} </option> ))}
              </select>
            }
          </label>

          {setlang === "en" ? (
            formValues.delivered_by!="Post" && (
              <label>
              <p style={{margin:"9px"}}>Provide Delivery Details:</p>
                <input
                  name="pickup_address"
                  value={formValues.pickup_address}
                  onChange={handleChange}
                />
              </label>
          )
          ):(
            formValues.delivered_by!="پست" && (
              <label >
              <p style={{margin:"9px"}}>روش ارسال محصول به خریدار</p>
                <input
                  name="pickup_address"
                  value={formValues.pickup_address}
                  onChange={handleChange}
                />
              </label>
          ))}
        </div>

        {/* 
        {bids.length <=0 ? (        
          <div className="form-options">
            {setlang === "en" ?
            <label className="checkbox-inline">
              {setlang === "en" ? "Is Biddable?" : "قابل مزایده؟" }
              <input
                type="checkbox"
                name="is_biddable"
                checked={formValues.is_biddable}
                onChange={handleChange}
              />
            </label>
            :
            <label className="checkbox-inline">
              <input
                type="checkbox"
                name="is_biddable"
                checked={formValues.is_biddable}
                onChange={handleChange}
                />
                {setlang === "en" ? "Is Biddable?" : "قابل مزایده؟" }
            </label>
            }
          </div>
        ):(
          <label className="form-options"><small>
            {setlang === "en" ? "There is ongoing bidding for this item. Changing item's status or its deadline during bidding is not possible."
            : "در حال حاظر مزایده با پیشنهاد های ارایه شده در حال انجام است. امکان تغییر مدل فروش و یا تغییر تاریخ مزایده در این شرایط وجود ندارد"}
          </small></label>
        )}
          */}

        {formValues.is_biddable && (
          bids.length <= 0 ? (
          <label style={{gap:"120px"}}>
            {setlang === "en" ? "Bidding Deadline" : "تاریخ و زمان پایان مزایده" }
            <DatePicker
              style={{margin:"10px", direction:"ltr"}}
              calendar={persian}
              locale={setlang==="en"?persian_en:persian_fa}
              format="YYYY/MM/DD HH:mm"
              plugins={[ <TimePicker position="bottom" /> ]}
              value={formValues.bidding_deadline ? new DateObject(new Date(formValues.bidding_deadline)) : null}
              onChange={(dateObject) => {
                if (!dateObject) return;

                setFormValues((prev) => ({
                  ...prev,
                  bidding_deadline: dateObject.toDate().toISOString(),
                }));
              }}
            />
          </label>
          ):(
            <div />
          )
        )}

        <div className="media-upload">
          <label >
            {setlang === "en" ? "Choose Images & Videos" : "بارگذاری عکس و ویدیو" }
            <input
              ref={mediaInputRef}
              type="file"
              accept="image/*,video/*"
              multiple
              onChange={handleMediaChange}
            />
          </label>

          {/* Preview summary */}
          <div className="media-summary">
            {images.length > 0 && <div>{images.length} {setlang === "en" ? "image(s) selected" : "عکس" }</div>}
            {videos.length > 0 && <div>{videos.length} {setlang === "en" ? "video(s) selected" : "ویدیو" }</div>}
          </div>
        </div>

        <div className="existing-media">
          <div className="existing-media-grid">
            {existingImages?.map((img) => (
              <div key={img.id} className="media-item">
                <img src={img.image} alt="product" width="100" />
                <button type="button" onClick={() => {
                                      markForDeletion("images", img.id);
                  }}>
                  &#10005; {setlang === "en" ? "Delete" : "حذف" }
                </button>
              </div>
            ))}
            {existingVideos?.map((vid) => (
              <div key={vid.id} className="media-item">
                <video src={vid.video} width="120" controls />
                <button type="button" onClick={() => {markForDeletion("videos", vid.id);}}>
                  &#10005; {setlang === "en" ? "Delete" : "حذف" }
                </button>
                </div>
              ))}
          </div>
        </div>

        <div className="form-button-container">
          <button type="submit" className="butn-add">{setlang === "en" ? "Update Product" : "به روزرسانی آگهی" }</button>
          {product && (
            <button type="button" className="butn-remove" onClick={onCancel}>{setlang === "en" ? "Cancel" : "لغو" }</button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ProductForm;
